import React, { createContext, useContext, useState } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem('ehrm_user');
    return stored ? JSON.parse(stored) : null;
  });

  const adminLogin = async (username, password) => {
    const r = await api.post('/auth/admin-login', { username, password });
    const u = { ...r.data, token: r.data.token };
    localStorage.setItem('ehrm_user', JSON.stringify(u));
    localStorage.setItem('ehrm_token', r.data.token);
    setUser(u);
    return u;
  };

  const employeeLogin = async (nic) => {
    const r = await api.post('/auth/employee-login', { nic });
    const u = { ...r.data, token: r.data.token };
    localStorage.setItem('ehrm_user', JSON.stringify(u));
    localStorage.setItem('ehrm_token', r.data.token);
    setUser(u);
    return u;
  };

  const logout = () => {
    localStorage.removeItem('ehrm_user');
    localStorage.removeItem('ehrm_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, adminLogin, employeeLogin, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
